import defaultSchema from './default.schema';

export default {
  ...defaultSchema,

  title: 'Zmiana hasła',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Podaj swoje hasło',
      fieldRequired: true
    },
    newPassword: {
      type: 'string',
      title: 'Nowe hasło',
      fieldRequired: true,
      minLength: 8,
      validFunc: 'new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*._()?])").test($value)',
      validationMessages: {
        required: 'Hasło jest wymagane',
        minLength: 'Minimalna długość hasła wynosi 8',
        validFunc: 'Hasło powinno zawierać przynajmniej jedną dużą literę, jedną małą literę, cyfrę oraz znak specjalny'
      }
    },
    confirmPassword: {
      type: 'string',
      title: 'Powtórz nowe hasło',
      computed: true,
      fieldRequired: true,
      validFunc: '$value && this.newPassword ? $value === this.newPassword : true',
      validationMessages: {
        required: 'Powtórzenie hasła jest wymagane',
        validFunc: 'Oba hasła muszą być takie same'
      }
    }
  }
};
